import { useState } from "react";

import { IDialogProps, Stack, SubmissionForm, useTheme } from "@bps/fluent-ui";

import { CommandsEdit } from "./command";
import { JobsConfigurationFormValues } from "./dtos";
import { JobsConfigurationForm } from "./JobsConfigurationForm";

interface JobsConfigurationProps extends Pick<IDialogProps, "onDismiss"> {
  initialValues: JobsConfigurationFormValues;
  onUpdate: (value: JobsConfigurationFormValues) => void;
}

export const JobsConfiguration: React.FC<JobsConfigurationProps> = ({
  initialValues,
  onUpdate,
  onDismiss
}) => {
  const theme = useTheme();

  const handleSubmit = async (values: JobsConfigurationFormValues) => {
    onUpdate(values);
  };

  const dismiss = () => {
    onDismiss?.();
  };

  const [selectedJobId, setSelectedJobId] = useState<string | undefined>(
    initialValues.jobs[0]?.id
  );

  return (
    <SubmissionForm<JobsConfigurationFormValues>
      onSubmit={handleSubmit}
      cancelButtonProps={{ text: "Close", onClick: dismiss }}
      initialValues={initialValues}
    >
      {() => (
        <Stack
          horizontal
          verticalFill
          tokens={{ childrenGap: theme.spacing.m }}
          styles={{
            root: {
              height: "600px"
            }
          }}
        >
          <Stack
            styles={{
              root: {
                minWidth: "400px",
                height: "600px",
                maxHeight: "800px"
              }
            }}
          >
            <JobsConfigurationForm
              selectedJobId={selectedJobId}
              setSelectedJobId={setSelectedJobId}
            />
          </Stack>
          <Stack verticalFill styles={{ root: { width: "100%" } }}>
            <CommandsEdit selectedJobId={selectedJobId} />
          </Stack>
        </Stack>
      )}
    </SubmissionForm>
  );
};
